<mat-toolbar class="stick-top">Script Debugging/Testing</mat-toolbar>

<div class="padded">
  <table class="basicTable" style="width: 100%">
    <thead>
    <tr>
      <th colspan="100">Script</th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td colspan="100">
        <micro-ace-editor #editorRespScript="ngModel"
                          class="mono"
                          style="height: 250px;width: 100%;"
                          [(ngModel)]="script"
                          mode="groovy"
                          [canFullscreen]="true"
                          name="editorScript"
                          id="editorScript">
        </micro-ace-editor>
      </td>
    </tr>
    <tr>
      <th colspan="100">Context Variables</th>
    </tr>
    <tr>
      <th>Source</th>
      <th>Name</th>
      <th>Value</th>
      <th></th>
    </tr>
    <tr *ngFor="let v of descriptorVars | keyvalue">
      <td>Descriptor</td>
      <td><input [(ngModel)]="v.key" readonly ></td>
      <td><input [(ngModel)]="v.value" readonly></td>
      <td></td>
    </tr>
    <tr>
      <td>Session Default</td>
      <td><input value="companyId" readonly ></td>
      <td><input [value]="chatApp.hosted ? chatApp.hostedCompanyId : chatApp.companyId" readonly></td>
      <td></td>
    </tr>
    <tr>
      <td>Session Default</td>
      <td><input value="msisdn" readonly ></td>
      <td><input [value]="authService.getUser().msisdn" readonly></td>
      <td></td>
    </tr>
    <tr>
      <td>Session Default</td>
      <td><input value="msg" readonly ></td>
      <td><input [(ngModel)]="msg" name='msg'></td>
      <td></td>
    </tr>

    <tr *ngFor="let v of vars; let i = index">
      <td>Session</td>
      <td><input [(ngModel)]="v.name" [name]='"var_name_" + v.name'></td>
      <td><input [(ngModel)]="v.value" [name]='"var_value_" + v.name'></td>
      <td>
        <button type="button" (click)="removeVar(i)">Remove</button>
      </td>
    </tr>
    <tr>
      <td></td>
      <td><input placeholder="Name" [(ngModel)]="newVar.name" name="newVar_name"></td>
      <td><input placeholder="Value" [(ngModel)]="newVar.value" name="newVar_value"></td>
      <td>
        <button type="button" (click)="addVar()">Add</button>
      </td>
    </tr>
    </tbody>
  </table>
</div>

<div class="padded">
  <button mat-raised-button class="primary" [disabled]="!script || !script.trim().length" type="button" (click)="testScript()">Run Script</button>
</div>
<mat-progress-bar *ngIf="testRunning" mode="indeterminate"></mat-progress-bar>
<div *ngIf="testResponse">
  <div class="padded">
    <table class="full-width">
      <tr>
        <td>
          <mat-toolbar>Script Log</mat-toolbar>
          <div class="xpadded">
            <table class="basicTable" style="width: 100%;">
              <tr *ngIf="testResponse.error">
                <td style="width: 100px;font-weight: bold;">Error</td>
                <td>{{testResponse.error}}</td>
              </tr>
              <tr *ngIf="testResponse.errorDetail">
                <td style="width: 100px;font-weight: bold;">Error Detail</td>
                <td><textarea class="mono" style="width: 100%;" rows="20" name="errorDetail" readonly [value]="testResponse.errorDetail"></textarea></td>
              </tr>
              <tr *ngIf="testResponse.log">
                <td colspan="99">
                  <textarea class="mono" style="width: 100%;" rows="10" name="evalLog" readonly [value]="testResponse.log"></textarea>
                </td>
              </tr>
              <tr *ngIf="!testResponse.log">
                <td colspan="99">
                  <i>No script log</i>
                </td>
              </tr>
            </table>
          </div>
        </td>
        <td>
          <ng-container *ngIf="testResponse && !testResponse.error">
            <mat-toolbar>Script Response</mat-toolbar>
            <div class="xpadded">
              <table class="basicTable" style="width: 100%;">
                <tr>
                  <td colspan="99">
                    <ng-container *ngIf="!testResponse.response">
                      <i>Nothing returned from script</i>
                    </ng-container>
                    <ng-container *ngIf="testResponse.response">
                      <textarea class="mono full-width" rows="10" readonly [value]="testResponse.response"></textarea>
                    </ng-container>

                  </td>
                </tr>
              </table>
            </div>
          </ng-container>
        </td>
      </tr>
    </table>
  </div>

  <div class="padded">
    <table class="basicTable" style="width: 100%;">
      <tr>
        <th colspan="100">Context Variables</th>
      </tr>
      <tr>
        <th>Name</th>
        <th>Value</th>
        <th></th>
      </tr>
      <tr *ngFor="let v of testResponse.vars">
        <td><input [(ngModel)]="v.name" readonly ></td>
        <td><input [(ngModel)]="v.value" readonly></td>
      </tr>
    </table>
  </div>
</div>
